// ATLAS Dispatcher — test-phase limits.
// Loosen here after we have real usage data.
// IMPORTANT: edge fn mirrors these values — keep
// supabase/functions/check-dispatcher-watches/index.ts in sync.
export const DISPATCHER_LIMITS = {
  MAX_MATCHES_PER_WATCH_PER_RUN: 5,
  MAX_ACTIVE_WATCHES_PER_USER: 5,
  MAX_NOTIFICATIONS_PER_CRON_RUN: 100,
  MAX_EMAILS_PER_USER_PER_DAY: 5,
  MAX_AUTO_SCORES_PER_USER_PER_DAY: 10,
  RATE_FLOOR_USD: 1500,
  RPM_FLOOR_USD: 1.5,
} as const;

export const DISPATCHER_ERRORS = {
  WATCH_LIMIT:
    "You've reached the 5-watch limit. Delete or pause a watch to add a new one.",
  BROAD_CRITERIA:
    "Watch is too broad. Add a specific origin (city + state), destination region, equipment type, or a rate floor of at least $1,500 / $1.50 per mile.",
} as const;

export interface WatchCriteriaInput {
  current_city?: string | null;
  current_state?: string | null;
  destination_city?: string | null;
  destination_state?: string | null;
  destination_states?: string[] | null;
  equipment_types?: string[] | null;
  min_rate?: number | null;
  min_rpm?: number | null;
}

export function validateWatchCriteria(
  p: WatchCriteriaInput
): { ok: true } | { ok: false; error: string } {
  const hasOriginCity = !!(p.current_city && p.current_state);
  const destStates = p.destination_states || [];
  const hasDestRegion = destStates.length > 0 && destStates.length < 50;
  const hasDestCity = !!(p.destination_city && p.destination_state);
  const hasEquip = (p.equipment_types || []).length > 0;
  const hasRateFloor =
    (typeof p.min_rate === "number" && p.min_rate >= DISPATCHER_LIMITS.RATE_FLOOR_USD) ||
    (typeof p.min_rpm === "number" && p.min_rpm >= DISPATCHER_LIMITS.RPM_FLOOR_USD);
  if (hasOriginCity || hasDestRegion || hasDestCity || hasEquip || hasRateFloor) {
    return { ok: true };
  }
  return { ok: false, error: DISPATCHER_ERRORS.BROAD_CRITERIA };
}
